import { db } from "./firebase";
import { collection, doc, setDoc, getDoc, updateDoc, deleteDoc, getDocs, query, where } from "firebase/firestore";

const auditService = {
    async logUserAction(_userId, _action, _details) {},
    async logActivity() {},
};

const gamificationService = {
    async checkAndUpdateAgentAchievements() {},
    async updateAgentProfile() {}
};

const AGENTS_COLLECTION = "agents";

class AgentServiceService {
    constructor() {
        // No hereda de BaseService
    }
    
    async createAgent(agentData, userId) {
        const agentRef = doc(collection(db, AGENTS_COLLECTION));
        const data = {
            ...agentData,
            usuarioId: userId,
            fechaCreacion: new Date().toISOString(),
            actualizadoEn: new Date().toISOString(),
            activo: true,
            isVerified: false,
            opportunitiesCreated: 0,
            successfulOperations: 0,
            totalManaged: 0,
            totalCommissions: 0,
            projectsCount: 0,
            successfulProjects: 0,
            badges: [],
            tier: "Newcomer",
            ranking: 0
        };
        if (agentData.isAgency) {
            if (agentData.agencyId) {
                data.agencyId = agentData.agencyId;
                data.isAgencyOwner = agentData.isAgencyOwner;
            } else {
                data.agencyName = agentData.agencyName;
                data.agencyDescription = agentData.agencyDescription;
                data.isAgencyOwner = true;
                data.isAgency = true;
            }
        }
        await setDoc(agentRef, data);
        await auditService.logUserAction(userId, "create_agent", { entity: "agent", entityId: agentRef.id, data });
        return agentRef.id;
    }
    
    async getAgencies() {
        const agenciesQuery = query(
            collection(db, AGENTS_COLLECTION),
            where("isAgency", "==", true),
            where("activo", "==", true)
        );
        const snapshot = await getDocs(agenciesQuery);
        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    }

    async getAgentsByAgency(agencyId) {
        const agentsQuery = query(
            collection(db, AGENTS_COLLECTION),
            where("agencyId", "==", agencyId),
            where("activo", "==", true)
        );
        const snapshot = await getDocs(agentsQuery);
        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    }

    async getAgentById(agentId) {
        const agentRef = doc(db, AGENTS_COLLECTION, agentId);
        const agentSnap = await getDoc(agentRef);
        if (!agentSnap.exists()) throw new Error("Agente no encontrado");
        return { id: agentSnap.id, ...agentSnap.data() };
    }

    async updateAgent(agentId, agentData, userId) {
        const agentRef = doc(db, AGENTS_COLLECTION, agentId);
        await updateDoc(agentRef, { ...agentData, actualizadoEn: new Date().toISOString() });
        await auditService.logUserAction(userId, "update_agent", { entity: "agent", entityId: agentId, data: agentData });
    }

    async deleteAgent(agentId, userId) {
        const agentRef = doc(db, AGENTS_COLLECTION, agentId);
        await deleteDoc(agentRef);
        await auditService.logUserAction(userId, "delete_agent", { entity: "agent", entityId: agentId });
    }

    async listAgents({ tipo, nombre, usuarioId } = {}) {
        let q = collection(db, AGENTS_COLLECTION);
        const filters = [];
        if (tipo) filters.push(where("tipo", "==", tipo));
        if (nombre) filters.push(where("nombre", ">=", nombre));
        if (usuarioId) filters.push(where("usuarioId", "==", usuarioId));
        if (filters.length > 0) {
            q = query(q, ...filters);
        }
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    }

    async associateOpportunity(agentId, opportunityId, userId) {
        const opportunityRef = doc(db, "opportunities", opportunityId);
        await updateDoc(opportunityRef, { agenteId: agentId });
        await auditService.logUserAction(userId, "associate_opportunity", { entity: "opportunity", entityId: opportunityId, agentId });
        const q = query(collection(db, "opportunities"), where("agenteId", "==", agentId));
        const querySnapshot = await getDocs(q);
        const opportunitiesCreated = querySnapshot.size;
        const opQ = query(collection(db, "operations"), where("agenteId", "==", agentId), where("estado", "==", "completada"));
        const opSnapshot = await getDocs(opQ);
        const successfulOperations = opSnapshot.size;
        let totalManaged = 0;
        opSnapshot.forEach(doc => { totalManaged += doc.data().monto || 0; });
        await gamificationService.checkAndUpdateAgentAchievements(agentId, { opportunitiesCreated, successfulOperations, totalManaged });
    }

    async getAgentByUserId(userId) {
        const q = query(collection(db, AGENTS_COLLECTION), where("usuarioId", "==", userId));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) return null;
        const docSnap = querySnapshot.docs[0];
        return { id: docSnap.id, ...docSnap.data() };
    }

    async updateAgentProfile() {}
}

export const agentService = new AgentServiceService();